var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6384 0.25001C3.99229 0.24858 3.3552 0.401693 2.78018 0.696595C2.20516 0.991497 1.70887 1.41965 1.33264 1.94539C0.956415 2.47113 0.711143 3.07924 0.617259 3.71907C0.523375 4.35889 0.583595 5.01191 0.792903 5.62372C1.00221 6.23554 1.35455 6.78844 1.82057 7.23637C2.28659 7.6843 2.85279 8.0143 3.47203 8.19887C4.09126 8.38344 4.74559 8.41725 5.38052 8.29747C6.01545 8.1777 6.6126 7.9078 7.12222 7.51028L9.85949 10.25L10.5742 9.53463L7.83695 6.79491C8.30118 6.19525 8.58822 5.47738 8.6655 4.72273C8.74279 3.96808 8.60723 3.20685 8.2742 2.52541C7.94117 1.84396 7.424 1.26956 6.78136 0.867375C6.13871 0.46519 5.39632 0.251314 4.6384 0.25001ZM4.6384 7.353C4.03687 7.353 3.44884 7.17446 2.94868 6.83997C2.44852 6.50547 2.0587 6.03004 1.8285 5.4738C1.59831 4.91756 1.53808 4.30548 1.65543 3.71498C1.77278 3.12447 2.06245 2.58206 2.4878 2.15633C2.91315 1.7306 3.45507 1.44067 4.04505 1.32321C4.63503 1.20576 5.24655 1.26604 5.8023 1.49644C6.35804 1.72685 6.83305 2.11702 7.16724 2.61763C7.50143 3.11823 7.67981 3.70679 7.67981 4.30886C7.67981 5.11622 7.35938 5.8905 6.789 6.46139C6.21863 7.03228 5.44503 7.353 4.6384 7.353Z",
    fill: "#071520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62464 3.80127H2.61084V5.32334H3.62464V3.80127Z",
    fill: "#071520"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66639 3.29395H5.65259V5.32337H6.66639V3.29395Z",
    fill: "#071520"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14515 2.78662H4.13135V5.3234H5.14515V2.78662Z",
    fill: "#071520"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.57123977702404f66130dce4fb1a8a54.svg";
export { ForwardRef as ReactComponent };